import React from 'react';
import Loadable from 'react-loadable';
export const Loading = () => (<div></div>);
export default loader => Loadable({
  loader,
  loading: Loading,
});
